<template>
    <div class="page-setting has-bc parent-frame batch-policy" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>
                {{$route.meta.title}}({{batchListTotal}})
                <word-tips-hover data="自動收租：開啟自動收租後，將於下期帳單的應繳日自動發送帳單給租客<br><br>收租提醒：在每月應繳日前五天時，平台將E-MAIL提醒企業及業務可新增帳單。" width="360px"></word-tips-hover>
            </h1>
            <div class="btn-group" v-if="hasSeletedHouse">
                <!-- <div v-if="bizAuth.collectRentNotify.hasRight" class="border-button single" @click="batchNotify('SEND_RENT_NOTIFY')">
                    開啟收租提醒
                </div> -->
                <div v-if="bizAuth.autoCollectRentSetting.hasRight" class="border-button single" @click="batchNotify('AUTO_CREATE_BILL')">
                    開啟自動收租
                </div>
                <!-- <div v-if="bizAuth.collectRentNotify.hasRight && bizAuth.autoCollectRentSetting.hasRight" class="default-button batch" @click="batchNotify('BOTH')">
                    開啟自動收租與收租提醒
                </div> -->
            </div>
        </div>
        <batch-notify-comp></batch-notify-comp>
    </div>
</template>
<script>
import batchNotifyComp from '@/components/bussiness/mgtCategory/leaseMgt/batchNotify/batchNotifyComp.vue';
import wordTipsHover from '@/components/bussiness/widges/tips/wordTipsHover.vue';

import { mapGetters } from 'vuex'


export default {
    data () {
        return {
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
        this.$store.dispatch('getBizLandlordPolicyList')
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('page-header')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        batchNotify: function (type) {
            this.$analyticsBiz.logEvent('批量通知', { screen_name: '批量通知'})
            this.$store.dispatch('updateBizBatchNotify', type)
            .then(()=>{
                this.$store.dispatch('setAlarmStatus', {status: true,title: '更新成功',type: 'success'})
            })
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            hasSeletedHouse: 'GET_BIZ_BATCH_NOTIFY_HAS_SELECTED_HOUSE',
            batchListTotal: 'GET_BIZ_BATCH_NOTIFY_LIST_TOTAL'
        })
    },
    components: {
        batchNotifyComp,
        wordTipsHover
    }
}
</script>
<style lang="scss">
    .batch-policy{
        .single{
            width: 132px;
            height: 44px;
        }
        .batch{
            width: 202px;
            height: 44px;
        }
        &.page-setting.fixed .table-list .table-list-title {
            width: 819px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/leaseMgt/batchNotify.vue